<template>
    <form class="cbs-payment-form" @submit.prevent="onSubmit">
        <!--<h3 class="cbs-payment-form-card-payment-title">Confirm by card:</h3>-->
        <div class="cbs-payment-form-card-payment">
            <div class="row cell">
                <div class="field">
                    <input id="ccNameField" class="input empty" type="text" placeholder="John Doe" v-model="nameOnCard" autocomplete="name">
                    <label for="ccNameField">Name on card</label>
                    <div class="baseline"></div>
                </div>
            </div>
            <div class="row cell">
                <div class="field">
                    <stripe-element type='card' :stripe="stripeId" :options="stripeOptions" @change="cardElementChanged" />
                    <label for="example2-card-number">Credit card details</label>
                    <div class="baseline"></div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <ul class="list-unstyled error">
                        <li v-for="item in paymentErrors" :key="item"> {{item}} </li>
                    </ul>
                    <!--<div class="error" v-show="paymentError">{{paymentError}}</div>-->
                </div>
            </div>
            <div class="row">
                <div class="col-12 cbs-payment-form-terms-and-cond">
                    <!--<label class="checkbox cCheckbox">
                    <input type="checkbox" id="acceptTermsAndCond" name="acceptTermsAndCond" value="false" v-model="acceptTermsAndCond" />
                    <span class="default"></span>
                </label>
                <label for="acceptTermsAndCond">
                <span class="cbs-payment-form-terms-and-cond-label-text">I accept Dooler</span> <a href="#" @click="showTerms()">Terms and Conditions</a>.
                </label>-->

                    <label class="check">
                        <input type="checkbox" class="regular-checkbox" name="acceptTermsAndCond" value="false" v-model="acceptTermsAndCond" />
                        <span class="checkmark"></span>
                        <span class="cbs-payment-form-terms-and-cond-label-text">I accept {{companyName}}</span> <a href="#" @click="showTerms()">Terms and Conditions</a>.
                    </label>
                    <!--<i class="fa fa-info-circle" aria-hidden="true"></i>
                By clicking 'Confirm Booking' you are accepting our <a href="#" @click="showTerms()">Terms and Conditions</a>-->
                </div>
            </div>
            <div class="row" v-show="percentageToCharge > 0 && this.percentageToCharge < 100">
                <div class="col-12 text-center">
                    <strong>Please note: </strong> {{companyName}} will charge your card <strong>
                        only {{percentageToCharge}} % of booking value
                        ({{totalChargeForConfirmation | round(2, true)}} {{selectedCar.currency}})
                    </strong> for confirmation.
                    The rest will be charged in booking day.
                    <br />
                    <br />
                    <strong>Many thanks for using our services!</strong>
                </div>
            </div>
            <button type="button" class="price-container book-button mt-20" v-on:click="makePayment()">
                <span>
                    <span v-show="isPaymentInProgress"><i class="fa fa-spinner fa-spin"></i></span>
                    Confirm Booking - {{selectedCar.totalPrice | round(2, true) }} {{selectedCar.currency}}
                </span>
            </button>
        </div>
        <!--<div class="row" v-if="shouldDoThreeDSecure">
        <div class="col">
            <iframe style="width: 100%; height: 100%;" :src="threeDSecureUrl" frameborder="0" />
        </div>
        </div>-->
            <!--<div class="row" style="max-width: 90%; margin: 0;">
            <div class="col">
                <ul class="list-unstyled error">
                    <li v-for="item in paymentErrors" :key="item"> {{item}} </li>
                </ul>
            </div>
        </div>-->

        <vue-modal class="termsModal" v-show="showTermsAndCond" @close="closeTermsAndCond">
            <template slot="header">
                <h2 class="text-center">Terms & Conditions</h2>
            </template>
            <template slot="body">
                <div v-html="companyTermsAndCondHtml">
                </div>
            </template>
            <template slot="footer">
                <button type="button"
                        class="btn btn-primary"
                        @click="closeTermsAndCond"
                        aria-label="Close modal">
                    Close
                </button>
            </template>
        </vue-modal>

        <vue-modal v-show="showThreeDSecureModal" @close="closeModal">
            <template slot="header">
                <h2 class="text-center">Processing 3D secure transaction...</h2>
            </template>
            <template slot="body">
                <iframe style="width: 100%; height: 100%; position: absolute; top: 0; bottom: 0; left: 0; right: 0;"
                        @onbeforeunload="threeDSecureClosed"
                        :src="threeDSecureUrl" frameborder="0" />
            </template>
            <template slot="footer">
                <div class="text-center">Please do not close browser</div>
            </template>
        </vue-modal>
    </form>
</template>

<script>
    "use strict";
    import HtmlPageService from "../services/htmlPageService.js"
    import Vue from "vue";
    import VueModal from './../components/vue-modal/modal.vue';
    import StripeElement from './../components/vue-stripe/cardElement.vue';
    import { Stripe } from './../components/vue-stripe/stripeElements.js';

    import Vuelidate from 'vuelidate';
    import { required, email } from 'vuelidate/lib/validators';
    import { round } from "../utils/filters.js"

    Vue.use(Vuelidate);

    export default {
        name: "PaymentForm",
        components: { StripeElement, VueModal },
        data: function () {
            return {
                nameOnCard: '',
                acceptTermsAndCond: false,
                showTermsAndCond: false,
                hasStripeSourceError: false, //used to diferentiate between server errors and local errors when creating stripe source 
                //paymentError: '',
                //paymentInProgress: false,
                //stripeId: 'pk_live_T1zG3FK86lrCmjucq4ppwoT3',
                stripeOptions: {
                    hidePostalCode: true,
                    style: {
                        base: {
                            color: 'black',
                            fontFamily: 'Open Sans, Arial, Helvetica, sans-serif',
                            fontSize: '16px', //isLaptop ? '10px' : '16px',
                            fontWeight: 400,
                            lineHeight: '32px',
                            fontSmoothing: 'antialiased'
                        }
                    },
                    classes: {
                        base: "input StripeElement",
                        focus: 'focused',
                        empty: 'empty',
                        invalid: 'invalid',
                    }
                }
            };
        },
        computed: {
            storeCustomer: function () { return this.$store.state.configuration.saveCustomerCardForLaterCharges; },
            percentageToCharge: function () {
                console.log(this.$store.state.configuration.percentageToChargeAtBookingTime);
                return this.$store.state.configuration.percentageToChargeAtBookingTime;
            },
            totalChargeForConfirmation: function () {
                if (this.percentageToCharge >= 0 && this.percentageToCharge < 100)
                    return this.selectedCar.totalPrice * this.percentageToCharge / 100;
                return this.selectedCar.totalPrice;
            },
            stripeId: function () {
                return this.$store.state.configuration.stripeId;
            },
            selectedCar: {
                get: function () {
                    var car = this.$store.state.bookingInfo.selectedCar;
                    if (!car) return {};
                    return car;
                }
            },
            isPaymentInProgress: function () { return this.$store.state.bookingInfo.payment.paymentInProgress; },
            showThreeDSecureModal: function () {
                return this.$store.state.bookingInfo.payment.threeDSecureInProgress;
            }, 
            threeDSecureUrl: function () {
                var paymentInfo = this.$store.state.bookingInfo.payment;
                if (!paymentInfo) return "";
                return paymentInfo.stripeThreeDSecureUrl;
            },
            paymentErrors: function () { return this.$store.state.bookingInfo.payment.errors; },
            companyName: function () {
                return this.$store.getters.companyName;
            },
            companyTermsAndCondHtml: function () {
                return this.$store.getters.companyTermsAndCondHtml;
            }
        },
        methods: {
            showTerms: function () {
                this.showTermsAndCond = !this.showTermsAndCond;
                this.$store.commit('setShowTermsAndCondModal', true);
            },
            closeTermsAndCond: function () {
                this.showTermsAndCond = false;
            },
            threeDSecureClosed: function () {
                console.log("3d closed");
            },
            closeModal: function () {
                console.log('close modal');
                this.isModalVisible = false;
            },
            makePayment: function () {
                console.log("make payment");
                if (!this.validateForm()) {
                    HtmlPageService.scrollElement('.error', 10);
                    return;
                }
                               
                if (this.isPaymentInProgress) return;
                this.$store.commit('setPaymentInProgress', true);
                var options = {
                    currency: this.selectedCar.currency,
                    usage: "single_use",
                    owner: {
                        name: this.nameOnCard
                    }
                };

                if (this.storeCustomer) options.usage = "reusable";

                Stripe.createSource(options).then(data => {
                    console.log(JSON.stringify(data.source));
                    if (data.error) {
                        this.$store.commit('setPaymentInProgress', false);
                        this.$store.commit('setPaymentErrors', [data.error.message]);
                        this.hasStripeSourceError = true;
                        return;
                    }
                    this.$store.commit('setStripeSource', data.source);
                    this.$store.dispatch('createBooking');
                });
               // }
            },
            validateForm: function () {
                if (!this.acceptTermsAndCond) {
                    this.$store.commit('setPaymentErrors', ['Please accept Terms & Conditions to complete your booking.']);
                    return false;
                }

                if (this.hasStripeSourceError && this.paymentErrors.length > 0)
                    return false;

                if (!this.nameOnCard) {
                    this.$store.commit('setPaymentErrors', ['Name on card is required.']);
                    return false;
                }

                this.$store.commit('setPaymentErrors', []);
                return true;
            },
            onSubmit: function () { },
            cardElementChanged: function (data) {
                console.log(data);
                if (data.error) {
                    this.$store.commit('setPaymentErrors', [data.error.message]);
                    this.hasStripeSourceError = true;
                }
                else {
                    this.$store.commit('setPaymentErrors', []);
                    this.hasStripeSourceError = false;
                }                
            },
        },
        validations: {
            nameOnCard: { required },
        },
        mounted: function () {
            // Floating labels
            var inputs = document.querySelectorAll('.cbs-payment-form .cbs-payment-form-card-payment .input');
            Array.prototype.forEach.call(inputs, function (input) {
                input.addEventListener('focus', function () {
                    input.classList.add('focused');
                });
                input.addEventListener('blur', function () {
                    input.classList.remove('focused');
                });
                input.addEventListener('keyup', function () {
                    if (input.value.length === 0) {
                        input.classList.add('empty');
                    } else {
                        input.classList.remove('empty');
                    }
                });
            });
        },
        filters: { round: round }
    }
</script>

<style>
    .cbs-payment-form {
        background-color: #fff;
        padding: 0;
        padding-top: 10px;
    }

        .cbs-payment-form .termsModal .modal-body {
            overflow-y: auto;
        }

        .cbs-payment-form .termsModal .modal-header {
            color: #ab8b64;
        }

        .cbs-payment-form .cbs-payment-form-title {
            font-size: 18px;
            margin-bottom: 5px;
        }

        .cbs-payment-form .cbs-payment-form-card-payment-title {
            font-size: 17px;
            margin-top: 30px;
            margin-bottom: 0;
        }

        /*.cbs-payment-form .cbs-payment-form-card-payment strong {
            font-weight: bolder !important;
        }

        .cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond {
            text-align: center;
            margin: 0 auto;
            color: #24b47e;
        }*/

        .cbs-payment-form .cbs-payment-form-card-payment strong {
            font-weight: bolder !important;
        }

        .cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond {
            max-width: 90%;
            text-align: center;
            margin: 0 auto;
            color: #24b47e;
        }

            .cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond label {
                position: initial;
                overflow: visible;
                white-space: initial;
                padding-left: 10px;
                color: black;
                text-align: left;
            }

                .cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond label .cbs-payment-form-terms-and-cond-label-text {
                    /*margin-left: 20px;*/
                    cursor: pointer;
                }

                    /*.cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond label {
                position: initial;
                overflow: visible;
                white-space: initial;
                width: auto;
                color: black;
                padding: 0;
                margin: 0;
            }

                .cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond label i {
                    display: flex;
                    vertical-align: middle;
                    float: left;
                    margin-top: 4px;
                    position: initial;
                    margin-right: 15px;
                }

            .cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond .radio input:checked + i:after,
            .cbs-payment-form .cbs-payment-form-card-payment .cbs-payment-form-terms-and-cond .checkbox input:checked + i:after {
                position: initial;
                padding-top: 2px;
                padding-left: 3px;
            }*/
                    .cbs-payment-form i.fa {
        font: normal normal normal 14px/1 FontAwesome;
    }

        .cbs-payment-form .stripe-element {
            display: block;
            width: 100%;
            height: 46px;
            padding: .375rem .75rem;
            font-size: 1rem;
            line-height: 1.5;
            color: #495057;
            background-color: #fff;
            background-clip: padding-box;
            border: #dee5ed 1px solid;
            box-shadow: none;
            border-radius: 3px;
            transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
        }

        .cbs-payment-form .cbs-payment-form-card-payment {
            width: 100%;
            margin: 0 auto;
            padding: 15px 15px;
            background-color: #fff;
        }

        .cbs-payment-form .error {
            color: #e25950;
            text-align: center;
            margin-bottom: 20px;
        }

        .cbs-payment-form .cbs-payment-form-card-payment {
        }

            .cbs-payment-form .cbs-payment-form-card-payment * {
                font-family: Source Code Pro, Consolas, Menlo, monospace;
                font-size: 16px;
                font-weight: 500;
            }

            .cbs-payment-form .cbs-payment-form-card-payment .row {
                display: -ms-flexbox;
                display: flex;
                margin: 0 5px 10px;
            }

            .cbs-payment-form .cbs-payment-form-card-payment .field {
                position: relative;
                width: 100%;
                height: 50px;
                margin: 0 10px;
            }

                .cbs-payment-form .cbs-payment-form-card-payment .field.half-width {
                    width: 50%;
                }

                .cbs-payment-form .cbs-payment-form-card-payment .field.quarter-width {
                    width: calc(25% - 10px);
                }

            .cbs-payment-form .cbs-payment-form-card-payment .baseline {
                position: absolute;
                width: 100%;
                height: 1px;
                left: 0;
                bottom: 0;
                background-color: #cfd7df;
                transition: background-color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
            }

            .cbs-payment-form .cbs-payment-form-card-payment label {
                position: absolute;
                width: 100%;
                left: 0;
                bottom: 8px;
                color: #cfd7df;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                transform-origin: 0 50%;
                cursor: text;
                z-index: 0;
                transition-property: color, transform;
                transition-duration: 0.3s;
                transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
            }

            .cbs-payment-form .cbs-payment-form-card-payment .input {
                position: absolute;
                width: 100%;
                left: 0;
                bottom: 0;
                padding-bottom: 7px;
                color: #32325d;
                background-color: transparent;
                z-index: 10;
            }

                .cbs-payment-form .cbs-payment-form-card-payment .input::-webkit-input-placeholder {
                    color: transparent;
                    transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
                }

                .cbs-payment-form .cbs-payment-form-card-payment .input::-moz-placeholder {
                    color: transparent;
                    transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
                }

                .cbs-payment-form .cbs-payment-form-card-payment .input:-ms-input-placeholder {
                    color: transparent;
                    transition: color 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
                }

                .cbs-payment-form .cbs-payment-form-card-payment .input.StripeElement {
                    opacity: 0;
                    transition: opacity 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
                    will-change: opacity;
                }

                .cbs-payment-form .cbs-payment-form-card-payment .input.focused,
                .cbs-payment-form .cbs-payment-form-card-payment .input:not(.empty) {
                    opacity: 1;
                }

                    .cbs-payment-form .cbs-payment-form-card-payment .input.focused::-webkit-input-placeholder,
                    .cbs-payment-form .cbs-payment-form-card-payment .input:not(.empty)::-webkit-input-placeholder {
                        color: #cfd7df;
                    }

                    .cbs-payment-form .cbs-payment-form-card-payment .input.focused::-moz-placeholder,
                    .cbs-payment-form .cbs-payment-form-card-payment .input:not(.empty)::-moz-placeholder {
                        color: #cfd7df;
                    }

                    .cbs-payment-form .cbs-payment-form-card-payment .input.focused:-ms-input-placeholder,
                    .cbs-payment-form .cbs-payment-form-card-payment .input:not(.empty):-ms-input-placeholder {
                        color: #cfd7df;
                    }

    .cbs-payment-form .cbs-payment-form-card-payment .input.focused + label,
    .cbs-payment-form .cbs-payment-form-card-payment .input:not(.empty) + label {
        color: #aab7c4;
        transform: scale(0.85) translateY(-25px);
        cursor: default;
    }

                    .cbs-payment-form .cbs-payment-form-card-payment .input.focused + label {
                        color: #24b47e;
                    }

                .cbs-payment-form .cbs-payment-form-card-payment .input.invalid + label {
                    color: #ffa27b;
                }

                .cbs-payment-form .cbs-payment-form-card-payment .input.focused + label + .baseline {
                    background-color: #24b47e;
                }

                .cbs-payment-form .cbs-payment-form-card-payment .input.focused.invalid + label + .baseline {
                    background-color: #e25950;
                }

            .cbs-payment-form .cbs-payment-form-card-payment input, .cbs-payment-form .cbs-payment-form-card-payment button {
                -webkit-appearance: none;
                -moz-appearance: none;
                -ms-appearance: none;
                -o-appearance: none;
                appearance: none;
                outline: none;
                border-style: none;
            }

            .cbs-payment-form .cbs-payment-form-card-payment .checkbox input {
                display: none;
                visibility: hidden;
            }

                .cbs-payment-form .cbs-payment-form-card-payment input:-webkit-autofill {
                    -webkit-text-fill-color: #e39f48;
                    transition: background-color 100000000s;
                    -webkit-animation: 1ms void-animation-out;
                }

            .cbs-payment-form .cbs-payment-form-card-payment .StripeElement--webkit-autofill {
                background: transparent !important;
            }

            .cbs-payment-form .cbs-payment-form-card-payment input, .cbs-payment-form .cbs-payment-form-card-payment button {
                -webkit-animation: 1ms void-animation-out;
            }

            .cbs-payment-form .cbs-payment-form-card-payment button {
                display: block;
                height: 40px;
                margin: 40px 15px 0;
                background-color: #24b47e;
                border-radius: 4px;
                color: #fff;
                text-transform: uppercase;
                font-weight: 600;
                cursor: pointer;
                width: 300px;
                margin: auto;
            }

            /*.cbs-payment-form .cbs-payment-form-card-payment input:active {
                background-color: #159570;
            }*/

            .cbs-payment-form .cbs-payment-form-card-payment .error svg {
                margin-top: 0 !important;
            }

                .cbs-payment-form .cbs-payment-form-card-payment .error svg .base {
                    fill: #e25950;
                }

            .cbs-payment-form .cbs-payment-form-card-payment .error svg .glyph {
                fill: #fff;
            }

        .cbs-payment-form .cbs-payment-form-card-payment .error .message {
            color: #e25950;
        }

        .cbs-payment-form .cbs-payment-form-card-payment .success .icon .border {
            stroke: #abe9d2;
        }

        .cbs-payment-form .cbs-payment-form-card-payment .success .icon .checkmark {
            stroke: #24b47e;
        }

        .cbs-payment-form .cbs-payment-form-card-payment .success .title {
            color: #32325d;
            font-size: 16px !important;
        }

        .cbs-payment-form .cbs-payment-form-card-payment .success .message {
            color: #8898aa;
            font-size: 13px !important;
        }

        .cbs-payment-form .cbs-payment-form-card-payment .success .reset path {
            fill: #24b47e;
        }

</style>